import {chartSwitcher} from './uitilities';

interface ChartSectionProps {
  guid: string;
  app: 'farm' | 'wholesaler';
  postType: string;
}
const ChartSection = ({guid, postType, app}: ChartSectionProps) => {
  return <>{chartSwitcher[postType]({guid, app})}</>;
};

export default ChartSection;
